export default __webpack_public_path__ + "static/media/whylogo4.cd01a396.png";